import { Injectable, EventEmitter } from '@angular/core';
@Injectable()
export class FlowService {
    // This event is emitted by the fetchdata component, when it has successfully loaded a new flow.
    // The NavMenu subscribest to this event to update the FlowPicker in the navigation bar to reflect the newly loaded flow.
    FlowChange:EventEmitter<string> = new EventEmitter();
}


// WEBPACK FOOTER //
// C:/git/flowdesigner/src/services/flow.service.ts